import { useState, useEffect } from 'react';
import DOMPurify from 'dompurify';

const useSearchHighlight = (initialContent) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [highlightedContent, setHighlightedContent] = useState(initialContent);

  // Helper function to escape special regex characters
  const escapeRegExp = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  useEffect(() => {
    if (searchTerm.length > 2) {
      const escapedSearchTerm = escapeRegExp(searchTerm);
      const regex = new RegExp(`(${escapedSearchTerm})`, 'gi');
      const highlighted = initialContent.replace(regex, '<span class="highlight">$1</span>');
      setHighlightedContent(DOMPurify.sanitize(highlighted));
    } else {
      setHighlightedContent(initialContent);
    }
  }, [searchTerm, initialContent]);

  useEffect(() => {
    if (searchTerm.length > 2) {
      setTimeout(() => {
        const firstHighlight = document.querySelector('.highlight');
        if (firstHighlight) {
          firstHighlight.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }
  }, [highlightedContent]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchTerm(value);
  };

  return {
    searchTerm,
    handleSearch,
    highlightedContent,
  };
};

export default useSearchHighlight;
